import { render, staticRenderFns } from "./ItemLoader.vue?vue&type=template&id=98f46018"
import script from "./ItemLoader.vue?vue&type=script&lang=js"
export * from "./ItemLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports